import * as firebase from "firebase/app";
import "firebase/database";
import "firebase/storage";

import { DOCUMENT_CREATE, DOCUMENT_FETCH, DOCUMENT_UPDATE } from "./types";

export const documentDeleteById = (data, files) => {
  return (dispatch) => {
    firebase
      .database()
      .ref("documents/" + data.id)
      .remove()
      .then(() => {
        const redirect = `/admin/documentdetail?id=${data.brand_id}&title=${data.brand_title}&type=${data.product_type}`;
        removeOldFile(files, redirect);
      });
  };
};

const removeOldFile = (src, redirect) => {
  const ref = firebase.storage().ref().child(src);
  // Delete the file
  ref
    .delete()
    .then(() => {
      window.location = redirect;
    })
    .catch((error) => {
      window.location = redirect;
    });
};

export const documentUpdate = (id, data, oldFiles) => {
  return (dispatch) => {
    dispatch({ type: DOCUMENT_UPDATE, payload: true });
    const redirect = `/admin/documentdetail?id=${data.brand_id}&title=${data.brand_title}&type=${data.product_type}`;
    if (data.url) {
      // Change both catalog and img
      const storage = firebase.storage().ref();
      // Upload Img
      const filename = Date.now() + "." + data.url.name.split(".").pop();
      const fileRef = storage.child("document/" + filename);
      fileRef.put(data.url).then(() => {
        fileRef.getDownloadURL().then((url) => {
          data.url = url;
          firebase
            .database()
            .ref("documents/" + id)
            .update(data)
            .then(async (res) => {
              removeOldFile(oldFiles, redirect);
            })
            .catch((err) => {
              dispatch({ type: DOCUMENT_UPDATE, payload: false });
            });
        });
      });
    } else if (data.url === "") {
      // No file change
      delete data.url;
      // delete data.catalog
      firebase
        .database()
        .ref("documents/" + id)
        .update(data)
        .then(async (res) => {
          window.location = redirect;
        })
        .catch((err) => dispatch({ type: DOCUMENT_UPDATE, payload: false }));
    }
  };
};

export const documentFetchBrand = () => {
  return (dispatch) => {
    let documentsRef = firebase.database().ref("documents");
    documentsRef.once("value", (snapshot) => {
      let data = [];
      snapshot.forEach((childSnapshot) => {
        let item = childSnapshot.val();
        if (typeof item === "object") {
          data.push(item);
        }
      });
      const uniqueBrand = [
        ...new Map(data.map((item) => [item.brand_id, item])).values(),
      ];
      dispatch({ type: DOCUMENT_FETCH, payload: uniqueBrand });
    });
  };
};

export const documentFetchById = (id) => {
  return (dispatch) => {
    let documentsRef = firebase.database().ref("documents").child(id);
    documentsRef.once("value", (snapshot) => {
      const data = snapshot.val();
      dispatch({ type: DOCUMENT_FETCH, payload: [data] });
    });
  };
};

export const documentFetchByBrand = (brand_id) => {
  return (dispatch) => {
    let documentsRef = firebase
      .database()
      .ref("documents")
      .orderByChild("brand_id")
      .equalTo(brand_id);
    documentsRef.once("value", (snapshot) => {
      let data = [];
      snapshot.forEach((childSnapshot) => {
        let item = childSnapshot.val();
        if (typeof item === "object") {
          data.push(item);
        }
      });
      dispatch({ type: DOCUMENT_FETCH, payload: data.reverse() });
    });
  };
};

export const documentCreate = (data) => {
  return (dispatch) => {
    dispatch({ type: DOCUMENT_CREATE, payload: true });
    const filename = Date.now() + "." + data.url.name.split(".").pop();
    const storage = firebase.storage().ref();
    const fileRef = storage.child("document/" + filename);
    fileRef.put(data.url).then(() => {
      fileRef.getDownloadURL().then((url) => {
        data.url = url;
        const documentsRef = firebase.database().ref("documents").push();
        const id = documentsRef.key;
        data.id = id;
        documentsRef
          .set(data)
          .then((response) => {
            window.location = `/admin/documentdetail?id=${data.brand_id}&title=${data.brand_title}&type=${data.product_type}`;
          })
          .catch((err) => {
            console.log("documentCreate", err);
          });
      });
    });
  };
};
